import React, { createContext, useState, useContext } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [researcherFormName, setResearcherFormName] = useState("");

  return (
    <AppContext.Provider value={{ researcherFormName, setResearcherFormName }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
